import QueryDropdown, { QueryDropdownProps } from '@/components/QueryDropdown';
import { QueryInput, QueryInputType, queryInput } from '@/utils';
import { ReactNode, useCallback } from 'react';

import { DropdownItem } from '@/components/Dropdown';
import { fieldWrapper } from '@/components/Field';
import { getSelectUserFilter } from '@/api/services/users/searchUsers';

const DISPATCHER_ROLE_ID = '634cd544-0c78-11ed-82d4-0242ac190003';
const DRIVER_ROLE_ID = '634cdbdb-0c78-11ed-82d4-0242ac190003';
const LEADER_ROLE_ID = '9046d098-936f-11ed-83e3-0242ac160004';

type UserDropdownProps = Omit<QueryDropdownProps, 'query'> & {
  airports?: string[];
  query?: Record<string, QueryInput>;
};
const UserDropdown = ({ name = 'user', airports = null, query = {}, ...props }: UserDropdownProps): ReactNode => {
  const getItems = useCallback(async (): Promise<DropdownItem[]> => {
    const res = await getSelectUserFilter(airports || [], query);
    return (res || []).map(
      ({ id, fullName }): DropdownItem => ({
        label: fullName,
        keywords: fullName.split(' '),
        value: id,
      })
    );
  }, [airports, query]);

  return <QueryDropdown {...props} name={name} query={getItems} options={{ locale: props?.options?.locale || { 'Select...': 'User' } }} />;
};
export const DispatcherDropdown = (props: UserDropdownProps): ReactNode => (
  <UserDropdown
    {...props}
    query={{ roleId: queryInput([DISPATCHER_ROLE_ID], QueryInputType.OR) }}
    options={{ locale: props?.options?.locale || { 'Select...': 'Dispatcher' } }}
  />
);
export const DriverDropdown = (props: UserDropdownProps): ReactNode => (
  <UserDropdown
    {...props}
    query={{ roleId: queryInput([DRIVER_ROLE_ID], QueryInputType.OR) }}
    options={{ locale: props?.options?.locale || { 'Select...': 'Driver' } }}
  />
);
export const LeaderDropdown = (props: UserDropdownProps): ReactNode => (
  <UserDropdown {...props} options={{ locale: props?.options?.locale || { 'Select...': 'Leader' } }} />
);

export const UserDropdownField = fieldWrapper<UserDropdownProps>(UserDropdown);
export const DispatcherDropdownField = fieldWrapper<UserDropdownProps>(DispatcherDropdown);
export const DriverDropdownField = fieldWrapper<UserDropdownProps>(DriverDropdown);
export const LeaderDropdownField = fieldWrapper<UserDropdownProps>(LeaderDropdown);

export default UserDropdown;
